module.exports = __webpack_public_path__ + "static/media/file-js.a28f7949.svg";